import { createContext, useContext, useState } from "react";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [preselect, setPreselect] = useState(null);

  const openBooking = (serviceId = null) => {
    setPreselect(serviceId);
    setOpen(true);
  };

  return (
    <BookingContext.Provider value={{ open, setOpen, preselect, openBooking }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
